/**
 * Definicion de los 6 capitulos del tutorial interactivo.
 */

export interface ChapterDef {
  id: string;
  index: number;
  title: string;
  subtitle: string;
  persona: 'carlos' | 'maria' | 'juan' | 'luna' | null;
  icon: string; // lucide icon name mapped in the component
}

export const CHAPTERS: ChapterDef[] = [
  {
    id: 'intro',
    index: 0,
    title: 'Bienvenida',
    subtitle: 'Conoce al equipo de ACME Corporation',
    persona: null,
    icon: 'Users',
  },
  {
    id: 'configuracion',
    index: 1,
    title: 'Configuracion',
    subtitle: 'Carlos prepara los modelos de pricing',
    persona: 'carlos',
    icon: 'Settings',
  },
  {
    id: 'preparacion',
    index: 2,
    title: 'Preparando la Cotizacion',
    subtitle: 'Maria recibe un pedido de Banco Nacional',
    persona: 'maria',
    icon: 'FileText',
  },
  {
    id: 'calculando',
    index: 3,
    title: 'Calculando Precios',
    subtitle: 'Formulas, cascada de costos y margenes en vivo',
    persona: 'maria',
    icon: 'Calculator',
  },
  {
    id: 'aprobacion',
    index: 4,
    title: 'Aprobacion',
    subtitle: 'Juan revisa y aprueba la cotizacion',
    persona: 'juan',
    icon: 'CheckCircle',
  },
  {
    id: 'avanzado',
    index: 5,
    title: 'Tips Avanzados',
    subtitle: 'Multi-seccion, lookup tables y quiz final',
    persona: null,
    icon: 'Sparkles',
  },
];
